import DuperbrowsePaddles from './DuperbrowsePaddles';
import DuperbrowsePaddlesContainer from './DuperbrowsePaddles.container';
export default DuperbrowsePaddlesContainer(DuperbrowsePaddles);
//# sourceMappingURL=index.js.map